module.exports = __webpack_public_path__ + "img/users-solid-table.fd7de242.svg";